module.exports = __webpack_public_path__ + "pc/img/about-global-pic02.7e0a99a0.png";